// House Model and PCF framework compliance: the routes and the sidebar rows of `dowgate.compliance.house-model` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'dowgate.compliance.house-model',
    routes: [
        {
            frontend: 'desk',
            path: 'framework-compliance',
            lazy: () => import('@/pages/desk/framework-compliance/page'),
        },
        {
            frontend: 'desk',
            path: 'framework-compliance/model/:modelId',
            lazy: () => import('@/pages/desk/framework-compliance/model/page'),
        },
        {
            frontend: 'desk',
            path: 'deviation/:deviationId',
            lazy: () => import('@/pages/desk/deviation/page'),
        },
    ],
});
